import { HttpClient } from "./http-client"
import { apiUrl } from "./api-urls"
import { toCamel } from "../utils/apiResponse"
import {
  PricingPlanResponseModel,
  VerifyPromoResponse,
} from "../components/models"
class PlanService {
  httpClient = new HttpClient()

  async getMainSignUpPricingPageData(
    promoCode,
    affiliateSource = "",
    signUpPlanId
  ) {
    try {
      let param = new URLSearchParams()
      param.append("promoCode", promoCode)
      if (affiliateSource) {
        param.append("sourceId", affiliateSource)
      }
      if (signUpPlanId) {
        param.append("pId", signUpPlanId)
      }
      const response = await this.httpClient.get(
        apiUrl.getMainSignUpPricingPageData,
        param
      )
      const { Success, Data } = response.data
      if (Success && Data) {
        return new PricingPlanResponseModel(toCamel(Data))
      }
      return null
    } catch (e) {
      console.log(e)
      return null
    }
  }

  async saveAddOnitemsDetailForSignUpFromPricingPlan(
    signUpPricingPlanItemsRequestVM
  ) {
    try {
      const response = await this.httpClient.post(
        apiUrl.saveAddOnitemsDetailForSignUpFromPricingPlan,
        signUpPricingPlanItemsRequestVM
      )
      if (response.data.Data) {
        if (response.data.Data.Success) {
          return toCamel(response.data.Data)
        }
        alert(response.data.Data.ErrorMessage)
      }
      return ""
    } catch (e) {
      return ""
    }
  }

  //isPaidPurchase: the caller is enrolling a PAID subscription (the signup tab). The API then rejects a
  //promo whose only incentives are trial-only (trial extension / free account) and drops those incentives
  //from a mixed promo; the pricing tab's pre-check leaves it false because it can still start a trial.
  async verifyPromoCode(
    promoCode,
    subscriptionTerm,
    purchaseAmount,
    affiliateSource = "",
    planId = "",
    isPaidPurchase = false
  ) {
    try {
      let param = new URLSearchParams()
      param.append("promoCode", promoCode)
      param.append("subscriptionTerm", subscriptionTerm)
      param.append("purchaseAmount", purchaseAmount)
      if (isPaidPurchase) {
        param.append("isPaidPurchase", "true")
      }
      if (affiliateSource) {
        param.append("source", affiliateSource)
      }
      if (planId) {
        param.append("planId", planId)
      }
      const response = await this.httpClient.get(apiUrl.verifyPromoCode, param)
      if (response.data.Data) {
        return new VerifyPromoResponse(toCamel(response.data.Data))
      } else {
        return new VerifyPromoResponse()
      }
    } catch (e) {
      return new VerifyPromoResponse()
    }
  }
}

export default new PlanService()
